import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridApi, GridOptions, ColDef, DomLayoutType, GridReadyEvent, ColumnApi, FilterChangedEvent, SortChangedEvent } from 'ag-grid-community';
import { VendorAppPromotedRendererComponent } from '../../cell-renderers/vendor-app-promoted-renderer/vendor-app-promoted-renderer.component';
import { ManagementService } from 'src/app/management/services/management.service';
import { PaginationPageSizes, StorageKeyNamesManage } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';
import { SharedDataService } from 'src/app/shared/shared-data.service';

@Component({
  selector: 'app-vendor-app-list',
  templateUrl: './vendor-app-list.component.html',
  styleUrls: ['./vendor-app-list.component.scss']
})
export class VendorAppListComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() isStoreParams: boolean;

  @Input() formSide: string;

  @Input() fromComponent: string;

  @Input() sectionName: string;

  idString = '';

  gridApi: GridApi;

  gridColumnApi: ColumnApi;

  public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  gridOptions: GridOptions;

  rowSelection: "single" | "multiple" = "single";

  selectedRows: any;

  public columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    sortable: true,
    cellDataType: false,
    minWidth: 100
  };

  public paginationPageSize = 10;

  public domLayout: DomLayoutType;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  style: any = {
    width: '100%',
    height: '100%'
  };

  paginationPageSizes = PaginationPageSizes;

  storedParams: any = {
    filterModel: {},
    sortModel: [],
    searchText: ''
  }

  constructor(private managementService: ManagementService, private storageService: StorageService,
    private sharedService: SharedService, private sharedDataService: SharedDataService
  ) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'vendorAppsGrid');
    this.columnDefs = [
      {
        flex: 1,
        headerName: 'Name',
        field: 'app_name',
        minWidth: 150,
      },
      {
        flex: 1,
        headerName: 'Description',
        field: 'short_description',
      },
      {
        flex: 1,
        minWidth: 150,
        headerName: 'Application Status',
        headerClass: 'header-label-center',
        cellRenderer: (params: any) => {
          let divOuter = document.createElement('div');
          divOuter.classList.add('text-center', 'fixed-badge');
          let divInner = document.createElement('div');
          divInner.classList.add('badge');
          if (params.data && params.data.app_status) {
            if (params.data.app_status === 'IN_REVIEW') {
              divInner.innerHTML = 'IN REVIEW';
              divInner.classList.add('btn-custom-info');
            } else if (params.data.app_status === 'SUBMITTED') {
              divInner.innerHTML = 'SUBMITTED';
              divInner.classList.add('btn-custom-info');
            } else if (params.data.app_status === 'PUBLISHED') {
              divInner.innerHTML = 'PUBLISHED';
              divInner.classList.add('btn-custom-pri');
            } else if (params.data.app_status === 'ALPHA') {
              divInner.innerHTML = 'ALPHA';
              divInner.classList.add('btn-custom-pri');
            } else if (params.data.app_status === 'BETA') {
              divInner.innerHTML = 'BETA';
              divInner.classList.add('btn-custom-pri');
            } else if (params.data.app_status === 'REVOKED') {
              divInner.innerHTML = 'REVOKED';
              divInner.classList.add('btn-custom-danger');
            } else {
              divInner.innerHTML = '';
            }
          } else {
            divInner.innerHTML = '';
          }
          divOuter.appendChild(divInner);
          return divOuter;
        },
        sortable: false
      },
      {
        flex: 1,
        headerName: 'Promoted Status',
        field: 'promoted_app',
        cellRenderer: 'vendorAppPromotedRenderer',
        headerClass: 'header-label-center',
        sortable: false
      },
      {
        flex: 1,
        headerName: 'Associated CSP(s)',
        headerClass: 'header-label-center',
        cellRenderer: (params: any) => {
          let divOuter = document.createElement('div');
          divOuter.classList.add('text-center');
          divOuter.title = 'View'
          let button = document.createElement('button');
          button.className = 'btn btn-sm btn-custom-pri';
          button.innerHTML = ' <i class="fa-regular fa-eye fa-fw"></i>';
          button.id = this.idString + 'vapBtn-' + params.rowIndex
          divOuter.appendChild(button);
          button.addEventListener('click', (event) => { this.viewPartners(params) });
          return divOuter;
        },
        sortable: false
      },
    ];
    this.gridOptions = {
      sortingOrder: ['asc', 'desc'],
      pagination: true,
      suppressPaginationPanel: false,
      paginationPageSize: this.paginationPageSize,
      animateRows: true,
      context: { componentParent: this },
      onGridReady: ($event: any) => {
        this.onGridReady($event);
      },
      onFilterChanged: (e: FilterChangedEvent) => {
        this.storedParams.filterModel = e.api.getFilterModel();
        this.saveGridParams();
      },
      onSortChanged: (e: SortChangedEvent) => {
        this.storedParams.sortModel = e.columnApi.getColumnState();
        this.gridColumnApi.applyColumnState({
          state: this.storedParams.sortModel
        });
        this.saveGridParams();
      },
    }
    this.frameworkComponents = {
      vendorAppPromotedRenderer: VendorAppPromotedRendererComponent,
    }
    this.operateTableConfigs();
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;
            }
          });
        });
    }
  }

  checkStoredParams(storedParams: any) {
    this.gridApi.setFilterModel(storedParams.filterModel);
    this.gridApi.onFilterChanged();
    if (storedParams.sortModel.length) {
      this.gridColumnApi.applyColumnState({
        state: storedParams.sortModel
      });
    }
  }

  viewPartners(params: any) {
    this.sharedDataService.associatedPartnersLinkSub.next(params);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.hideOverlay();
    const storedParams = this.storageService.getGridParams(this.formSide, this.fromComponent, StorageKeyNamesManage.vendorAppList);
    const filterModelLength = (storedParams && storedParams.filterModel) ? Object.keys(storedParams.filterModel).length : 0;
    const sortModelLength = (storedParams && storedParams.sortModel) ? (storedParams.sortModel).length : 0;
    if (storedParams && (filterModelLength || sortModelLength)) {
      this.checkStoredParams(storedParams);
    }
    // params.api.sizeColumnsToFit();
    window.setTimeout(() => {
      params.api.sizeColumnsToFit();
    }, 1000);
  }

  saveGridParams() {
    if (this.isStoreParams) {
      this.storageService.saveGridParams(this.storedParams, this.formSide, this.fromComponent, StorageKeyNamesManage.vendorAppList);
    }
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    this.rowEditedEvent.emit(event.data);
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.tableConfigOptions.searchText)
    } else if (!this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }
  }

}
